module.exports = __webpack_public_path__ + "img/goto.655d43d8.svg";